import { render, staticRenderFns } from "./areaDev.vue?vue&type=template&id=cc206a4e&scoped=true&"
import script from "./areaDev.vue?vue&type=script&lang=js&"
export * from "./areaDev.vue?vue&type=script&lang=js&"
import style0 from "./areaDev.vue?vue&type=style&index=0&id=cc206a4e&scoped=true&lang=css&"
import style1 from "./areaDev.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc206a4e",
  null
  
)

export default component.exports